import gql from 'graphql-tag';
import { addressFieldsFragment } from './addressFieldsFragment';
import { sanityDocumentFieldsFragment } from './sanityDocumentFieldsFragment';

export const locationFieldsFragment = gql`
  fragment AdminLocationFields on Location {
    ... on SanityDocument {
      ...AdminSanityDocumentFields
    }
    name
    address {
      ... on Address {
        ...AdminAddressFields
      }
    }
    archived
  }

  ${sanityDocumentFieldsFragment}
  ${addressFieldsFragment}
`;
